import { render, staticRenderFns } from "./DefaultReports.vue?vue&type=template&id=29318330&scoped=true&"
import script from "./DefaultReports.vue?vue&type=script&lang=js&"
export * from "./DefaultReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29318330",
  null
  
)

export default component.exports